import axios from 'axios';

const api = axios.create({
    baseURL: '/admin/api/uni-chat/'
});

// POST Methods
export const createChatRoom = (payload) => api.post('create', payload);
export const updateChatRoom = (payload) => api.post('edit', payload);
export const deleteChatRoom = (payload) => api.delete('delete', payload);
export const openChatRoom = (user_id) => api.post('user/' + user_id + '/open-chat-room');
export const isFloating = (payload) => api.post('room/is-floating', payload);
export const isCollapsed = (payload) => api.post('room/is-collapsed', payload);
export const sendMessage = (room_id, payload) => api.post('message/' + room_id, payload);
export const markAsRead = (room_id, payload) => api.post('message/' + room_id + '/mark-as-read', payload);
export const broadcastMessage = (room_id, payload) => api.post('message/' + room_id + '/sent', payload);
export const searchUsers = (payload) => api.post('search-user-chat', payload);

// GET Methods
export const getChatConversationList = () => api.get('rooms/load-chat-rooms');
export const getFloatingChatRooms = (is_floating) => api.get('rooms/' + is_floating);
export const getUserInRoom = (room_id) => api.get('room/' + room_id + '/user');
export const getGroupMember = (room_id) => api.get('room/' + room_id + '/member');
export const getUserInCall = (room_id) => api.get('user/call-coach/' + room_id);
export const getUserInVideoCall = (room_id) => api.get('user/video-coach/' + room_id);
export const getChatMessages = (room_id) => api.get('messages/' + room_id);
export const getMessage = (message_id) => api.get('message/' + message_id);
export const getBranches = () => api.get('group/load-branches');
export const getGroupChatRooms = () => api.get('group/chat-rooms');
export const getMoreChatMessages = (room_id, counter) => api.get('room/load-more/' + room_id + '/' + counter);